import AreaNames from "../../../mixins/area-name-list-search";
import ChecklistSets from "../../../mixins/checklist-sets-listing";

Vue.component("inspection-templates", {

    mixins: [AreaNames, ChecklistSets],

    props: ["inspectionTemplates"],

    data () {
        return {
            templates: this.inspectionTemplates,
            selectedTemplate: null,
            selectedTemplateArea: null,
            templateCreateForm: new AppForm({}),
            templateEditForm: new AppForm({}),
            templateAreaCreateForm: new AppForm({}),
            templateAreaEditForm: new AppForm({}),
        };
    },

    mounted () {
        if (this.templates && this.templates.length > 0) {
            this.showTemplate(this.templates[0]);
            this.loadChecklistSets();
        }
    },

    methods: {

        showTemplate (template) {
            this.selectedTemplate = template;
            this.templateEditForm = new AppForm(this.selectedTemplate);
            $("[data-toggle=\"tooltip\"]").tooltip();
        },

        showTemplateCreateForm () {
            $("#modal-template-create-form").modal("show");
        },

        hideTemplateCreateForm () {
            $("#modal-template-create-form").modal("hide");
            this.templateCreateForm = new AppForm({});
        },

        showTemplateAreaCreateForm () {
            $("#modal-template-area-create-form").modal("show");
        },

        hideTemplateAreaCreateForm () {
            $("#modal-template-area-create-form").modal("hide");
            this.templateAreaCreateForm = new AppForm({});
        },

        showTemplateAreaEditForm (area) {
            this.selectedTemplateArea = area;
            this.templateAreaEditForm = new AppForm(this.selectedTemplateArea);
            $("#modal-template-area-edit-form").modal("show");
        },

        createTemplate () {

            App.post("/settings/inspections/templates/create", this.templateCreateForm)
            .then(response => {
                this.templates.unshift(response);
                this.hideTemplateCreateForm();
                this.showTemplate(response);
            })
            .catch(errors => {
                toastr.error("Error creating template!");
            });

        },

        updateTemplate () {

            App.patch("/settings/inspections/templates/" + this.selectedTemplate.id + "/update", this.templateEditForm)
            .then(response => {

                const index = this.templates.findIndex(t => t.id === response.id);

                if (index !== -1) {
                    Vue.set(this.templates, index, response);
                }

                this.selectedTemplate = response;

                toastr.success("Template updated!");

            })
            .catch(() => {
                toastr.error("Error updating template!");
            });

        },

        showTemplateDeleteConfirmation () {

            let self = this;
            swal({
                title: "Delete " + this.selectedTemplate.name,
                text: "Are you sure you want to delete this inspection template?",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    self.deleteTemplate(this.selectedTemplate);
                }
            });

        },

        deleteTemplate (template) {

            axios.post("/settings/inspections/templates/" + template.id + "/delete", {_method: "DELETE"})
            .then(response => {
                this.removeDeletedTemplate(template);
                toastr.success("Template deleted!");
            })
            .catch(() => {
                toastr.error("Template could not be deleted!");
            });
        },

        removeDeletedTemplate (template) {
            const index = this.templates.indexOf(template);

            if (index !== -1) {
                this.templates.splice(index, 1);
            }

            if (this.selectedTemplate === template) {
                this.selectedTemplate = null;
            }

        },

        createTemplateArea () {

            App.post("/settings/inspections/templates/" + this.selectedTemplate.id + "/areas/create", this.templateAreaCreateForm)
            .then(response => {
                this.selectedTemplate.areas.push(response);
                this.setAreasSequenceFromIndex();
                this.hideTemplateAreaCreateForm();
            })
            .catch(() => {
                toastr.error("Error creating template area!");
            });

        },

        updateTemplateArea () {

            App.patch("/settings/inspections/templates/areas/" + this.selectedTemplateArea.id + "/update", this.templateAreaEditForm)
            .then(response => {

                toastr.success("Area saved!");
                const index = this.selectedTemplate.areas.findIndex(a => a.id === response.id);

                if (index !== -1) {
                    Vue.set(this.selectedTemplate.areas, index, response);
                }

                $("#modal-template-area-edit-form").modal("hide");

            })
            .catch(() => {
                toastr.error("Error updating area!");
            });

        },

        removeTemplateArea (area) {

            let self = this;
            swal({
                title: "Delete " + area.name,
                text: "Are you sure you want to delete this template area?",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {

                    axios.post("/settings/inspections/templates/areas/" + area.id + "/delete", {_method: "DELETE"})
                    .then(response => {
                        const index = self.selectedTemplate.areas.indexOf(area);

                        if (index !== -1) {
                            self.selectedTemplate.areas.splice(index, 1);
                            self.setAreasSequenceFromIndex();
                        }

                    })
                    .catch(() => {
                        toastr.error("Error deleting area!");
                    });

                }
            });

        },

        setAreasSequenceFromIndex () {
            this.selectedTemplate.areas.map((area, index) => {
                area.sequence_number = index + 1;
            });
        },

        updateTemplateAreaSequence () {

            this.setAreasSequenceFromIndex();

            var updatedAreas = this.selectedTemplate.areas.map(area => {
                return {"id": area.id, "sequence_number": area.sequence_number};
            });

            axios.post("/settings/inspections/templates/" + this.selectedTemplate.id + "/areas/order", {
                _method: "PATCH",
                "updatedAreas": updatedAreas
            }).then(response => {

            }).catch(errors => {
                toastr.error("Error reordering areas!");
            });

        },

    }

});